module.exports = __webpack_public_path__ + "img/icone_caixa.5b593407.png";